module.exports = __webpack_public_path__ + "img/1.5c8a4e3.png";